import e from"./InfiniteHits.vue_vue&type=script&lang.js";import{render as t}from"./InfiniteHits.vue_vue&type=template&id=0e2ba520&lang.js";e.render=t;export default e;
//# sourceMappingURL=InfiniteHits.vue.js.map
